import { ActivityToMapType } from 'app/constants/configuration/activityToMapType'

export const getActivityToMapType = (type: number): ActivityToMapType => {
  let activityToMapType = ActivityToMapType.Rest

  switch (type) {
    case 1:
      activityToMapType = ActivityToMapType.Availability
      break
    case 2:
      activityToMapType = ActivityToMapType.AvailabilityInCrew
      break
    case 3:
      activityToMapType = ActivityToMapType.Work
      break
  }

  return activityToMapType
}
